import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toggle from 'material-ui/Toggle';
import { AddressWrapperDiv, HeaderDiv, HeaderTitleDiv, HeaderIconImg } from '../../pages';
import AddressBar from '../../components/AddressBar';
import * as addressReducer from '../../reducers/addressReducer';

import './style.css'

const notifyIcon = process.env.PUBLIC_URL+'/assets/img/icons/menu/notification_dark.svg';
const styles = {
  headerIcon: { width:'43px' }
}
class NotificationsPage extends Component {
  styles = {
      toggle: {
        maxWidth: 60,
        // marginBottom: 16,
      },
      thumbOff: {
        backgroundColor: '#' + this.props.secondaryColor,
      },
      trackOff: {
        backgroundColor: '#c7d7bc',
      },
      thumbSwitched: {
        backgroundColor: '#' + this.props.secondaryColor,
      },
      trackSwitched: {
        backgroundColor: '#c7d7bc',
      },
      labelStyle: {
        color: '#' + this.props.secondaryColor,
      },
      pageTitle: { 
        fontFamily: 'montserrat', 
        fontSize:'28px', 
        color: '#626262', 
        fontWeight:'800', 
        margin:'0 0 0 17px'
      }
  };
  render() {
    const { isAddressBarOpened } = this.props;
    return (
      <div>
        <HeaderDiv>
          <HeaderIconImg style={styles.headerIcon} src={notifyIcon}/> 
          <HeaderTitleDiv>NOTIFICATIONS</HeaderTitleDiv> 
        </HeaderDiv>
        <div className="notification-options">
          <div style={{marginTop:'15px'}}>PUSH MESSAGES</div>
          <div style={{marginTop:'15px'}}className="toggle-container">
            <div style={{padding: '0 15px 0 0'}}>Allow</div>
             <Toggle
                style={this.styles.toggle}
                defaultToggled={true}
                thumbStyle={this.styles.thumbOff}
                trackStyle={this.styles.trackOff}
                thumbSwitchedStyle={this.styles.thumbSwitched}
                trackSwitchedStyle={this.styles.trackSwitched}
                labelStyle={this.styles.labelStyle}
              />
              <div style={{padding: '0 0 0 12px'}}>Do Not Allow</div>
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    secondaryColor: state.config.secondaryColor,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return { 
//   };
// };

export default connect(mapStateToProps, null)(NotificationsPage);


// WEBPACK FOOTER //
// ./src/components/NotificationsPage/NotificationsPage.jsx